import script from "./SearchFilter.vue?vue&type=script&lang=ts&setup=true"
export * from "./SearchFilter.vue?vue&type=script&lang=ts&setup=true"

import "./SearchFilter.vue?vue&type=style&index=0&id=4ce7da6b&scoped=true&lang=css"

import exportComponent from "E:\\Marianne\\workspace\\notion-cooks\\app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4ce7da6b"]])

export default __exports__